import type { IndicatorScope } from '@Application/Indicators/IndicatorScope';
import parameters from '../../parameters';

export default (scope: IndicatorScope): string => {
	switch (scope.kind) {
		case 'account':
			return `${parameters.api.host}/api/accounts/${scope.accountId}/indicators`;
		case 'organization':
			return `${parameters.api.host}/api/organizations/${scope.organizationId}/indicators`;
		case 'facility':
			return `${parameters.api.host}/api/facilities/${scope.facilityId}/indicators`;
	}
};
